import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PropertyImageListRequestBody, PropertyImageListResponse } from "./types";

export class PropertyImageListAPI extends BaseAPI<
    PropertyImageListRequestBody,
    PropertyImageListResponse
> {
    protected route = ApiRoutes.property.image;
    protected method = RequestMethod.GET;
}
